import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AOS from 'aos';
import 'aos/dist/aos.css';
import VueLazyload from 'vue-lazyload'
const loadimage = "https://www.taiyuangong.com/img/simple-loader.gif"
import CommonMethods from './common/common_methods'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.mixin(CommonMethods)
Vue.use(AOS)
Vue.use(VueLazyload, {
  loading: loadimage
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')